export default __webpack_public_path__ + "static/media/video.d9be6a60.png";